<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 197.21"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="75.552"
            cy="61.297"
            r="9.965"
        />

        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M63.31 12.151c-1.069,9.186 -0.14,18.009 2.785,26.468 -7.422,-0.149 -15.289,0.217 -23.602,1.096 3.408,-6.463 3.072,-14.978 -1.008,-25.546 7.636,2.021 14.911,1.349 21.825,-2.018z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M41.485 14.169c4.08,10.568 4.416,19.083 1.008,25.546 -8.151,0.863 -16.73,2.221 -25.737,4.073 -0.809,-2.257 -1.022,-4.811 -0.979,-8.516 0.042,-3.705 0.34,-8.561 1.192,-12.585 0.852,-4.024 2.258,-7.219 3.94,-9.774 1.682,-2.555 3.64,-4.472 5.876,-5.664 5.04,3.353 9.94,5.659 14.7,6.92z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M63.31 12.151c-6.914,3.367 -14.189,4.039 -21.825,2.018 -4.76,-1.261 -9.66,-3.567 -14.7,-6.92 2.236,-1.192 4.749,-1.661 7.283,-1.831 2.534,-0.171 5.089,-0.042 6.686,0.362 1.597,0.404 2.236,1.086 3.705,1.49 1.469,0.405 3.768,0.533 6.153,0.426 2.385,-0.106 4.856,-0.447 6.772,-0.872 1.917,-0.426 3.279,-0.937 5.046,-1.555 1.768,-0.617 3.94,-1.342 5.941,-1.49 2.002,-0.149 3.833,0.277 5.43,0.937 -3.399,3.206 -6.896,5.685 -10.491,7.435z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M42.493 39.715c8.313,-0.879 16.18,-1.245 23.602,-1.096 8.642,0.174 16.681,1.045 24.115,2.614 -0.513,2.098 -1.32,3.922 -2.398,5.302 -0.406,0.521 -0.851,0.979 -1.356,1.38 -1.375,1.089 -3.195,1.755 -5.905,2.113 -3.705,0.489 -9.071,0.404 -13.33,0.511 -4.258,0.106 -7.409,0.404 -11.476,0.809 -4.068,0.405 -9.05,0.915 -14.587,1.107 -5.536,0.192 -11.626,0.064 -15.182,-0.404 -3.556,-0.469 -4.578,-1.278 -5.792,-2.662 -0.704,-0.804 -1.474,-1.802 -2.154,-2.939 -0.491,-0.821 -0.935,-1.715 -1.274,-2.662 9.007,-1.852 17.586,-3.21 25.737,-4.073z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M18.03 46.45c-0.517,7.126 -0.661,14.397 -0.43,21.811 0.843,30.302 9.679,56.026 26.509,77.172 12.499,14.532 19.76,11.362 14.82,-8.177 -4.886,-19.323 -10.668,-34.582 -8.24,-48.357 1.904,-10.8 4.981,-10.275 8.591,-1.565 3.385,8.168 3.733,21.359 6.324,41.33 2.198,16.932 13.763,25.134 16.352,11.754 6.204,-32.051 4.41,-59.115 4.5,-92.503m1.292 -26.485c-1.107,-2.427 -2.427,-5.152 -4.067,-7.58 -1.639,-2.427 -3.598,-4.556 -5.259,-6.068 -1.661,-1.512 -3.024,-2.406 -4.621,-3.066 -1.597,-0.66 -3.428,-1.086 -5.43,-0.937 -2.001,0.148 -4.173,0.873 -5.941,1.49 -1.767,0.618 -3.129,1.129 -5.046,1.555 -1.916,0.425 -4.387,0.766 -6.772,0.872 -2.385,0.107 -4.684,-0.021 -6.153,-0.426 -1.469,-0.404 -2.108,-1.086 -3.705,-1.49 -1.597,-0.404 -4.152,-0.533 -6.686,-0.362 -2.534,0.17 -5.047,0.639 -7.283,1.831 -2.236,1.192 -4.194,3.109 -5.876,5.664 -1.682,2.555 -3.088,5.75 -3.94,9.774 -0.852,4.024 -1.15,8.88 -1.192,12.585 -0.043,3.705 0.17,6.259 0.979,8.516 0.809,2.258 2.215,4.217 3.428,5.601 1.214,1.384 2.236,2.193 5.792,2.662 3.556,0.468 9.646,0.596 15.182,0.404 5.537,-0.192 10.519,-0.702 14.587,-1.107 4.067,-0.405 7.218,-0.703 11.476,-0.809 4.259,-0.107 9.625,-0.022 13.33,-0.511 3.705,-0.49 5.749,-1.555 7.261,-3.493 1.512,-1.937 2.491,-4.748 2.874,-7.963 0.384,-3.215 0.171,-6.835 -0.383,-9.71 -0.553,-2.874 -1.448,-5.004 -2.555,-7.432z"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="81.325"
            cy="151.695"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
